export const initialState = () => ({
  loading: {
    show: false,
    message: ""
  },
  currentStep: 1
})
